<template>
  <v-skeleton-loader
    :loading="isLoading"
    transition="expand-transition"
    type="article"
  >
    <FormRecipeVerification
      :RecipeVerification="editRecipeVerification"
      :isSaving="isSaving"
      :isCompleted="isCompleted"
      @save="save"
      @cancel="$router.push({name: from.name })" />
  </v-skeleton-loader>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import dayjs from 'dayjs';
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import FormRecipeVerification from '../components/FormRecipeVerification.vue';
import checklist from './checklist';
import formatting from '../mixins/formatting';
import stockItem from './stockItem';

export default {
  components: {
    FormRecipeVerification,
  },
  name: 'EditRecipeVerification',
  module: 'RecipeVerification',
  mixins: [checklist, formatting, loading, stockItem],
  data() {
    return {
      /**
      * Get/Set editing RecipeVerification. Default to {}.
      */
      editRecipeVerification: {},
      /**
       * Query Id for RecipeVerification
       */
      recipeVerificationId: this.$route?.query.id,
      /** Get the mode for this view, create or update
      */
      mode: 'add',
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('recipeVerifications', ['recipeVerifications', 'recipeVerification']),
  },
  async mounted() {
    this.$on('stockItem.loaded', (item) => {
      this.isLoading = true;
      if (item.recipeVerifications?.length > 0) {
        // eslint-disable-next-line prefer-destructuring
        this.editRecipeVerification = item.recipeVerifications[0];
        this.mode = 'edit';
      } else {
        this.editRecipeVerification.stockItemId = item.id;
        this.editRecipeVerification.date = this.formatDate(item.productionDate);
        this.editRecipeVerification.farm = item.deliveryNote.farm.farmCode;
        if (item.canEndInspections.length > 0) {
          this.editRecipeVerification.canningCode = item.canEndInspections[0].canningCode;
        }
        this.editRecipeVerification.brandingCode = this.formatProductionCode(item);
        this.editRecipeVerification.bestBefore = this.formatDate(dayjs(item.productionDate).add(5, 'year').toISOString());
        this.editRecipeVerification.product = 'Abalone';
      }
      this.isLoading = false;
      this.$log.info('Prepopulation completed');
      this.$forceUpdate();
    });
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('recipeVerifications', ['LOAD_recipeVerification', 'CREATE_recipeVerification', 'UPDATE_recipeVerification']),
    /** Method used to save the item
     */
    async save(recipeVerification) {
      this.isSaving = true;
      if (this.mode === 'add') {
        await this.CREATE_recipeVerification(recipeVerification);
      } else {
        await this.UPDATE_recipeVerification(recipeVerification);
      }
      this.isSaving = false;
      this.$router.push({ name: 'processing-ListFactoryItem' });
    },
  },
};
</script>

<docs>
# EditRecipeVerification example

'''js
<EditRecipeVerification :RecipeVerification="RecipeVerification" />
'''
</docs>
